import { CommonModule } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { patchPersonalDataFormGroup } from '@app/helpers/personal-data-form-patch.helper';
import { ProfileEditComponent } from '@app/components/profile-edit/profile-edit.component';
import { PersonalDataFormGroup } from '@app/models/form.models';
import { AuthStore } from '@app/stores/auth.store';
import { TranslateModule } from '@ngx-translate/core';
import { GenericStore } from 'src/app/+store/generic.store';

@Component({
  selector: 'app-personal-data-step-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    ProfileEditComponent,
  ],
  templateUrl: './personal-data-step-form.component.html',
  styleUrl: './personal-data-step-form.component.scss',
})
export class PersonalDataStepFormComponent {
  public store = inject(GenericStore);
  public formGroupInput = input.required<FormGroup<PersonalDataFormGroup>>();
  public authStore = inject(AuthStore);

  constructor() {
    effect((onCleanup) => {
      const nameTitles = this.store.nameTitlesEntities();
      if (nameTitles.length === 0) {
        return;
      }

      const sub = this.authStore.loadPersonalData().subscribe((person) => {
        patchPersonalDataFormGroup(
          this.formGroupInput(),
          person,
          nameTitles,
        );
      });
      onCleanup(() => sub.unsubscribe());
    });
  }
}
